export enum NotificationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS',
  IN_APP = 'IN_APP',
  INAPP = 'INAPP',
}

export enum NotificationTopic {
  SYSTEM = 'SYSTEM',
  CLASS = 'CLASS',
  ASSIGNMENT = 'ASSIGNMENT',
  DEADLINES = 'DEADLINES',
  MESSAGES = 'MESSAGES',
  NEWSLETTER = 'NEWSLETTER',
  MARKETING = 'MARKETING',
  ACTIVITY = 'ACTIVITY',
  GRADES = 'GRADES',
  HOMEWORK = 'HOMEWORK',
  EVENTS = 'EVENTS',
  REMINDERS = 'REMINDERS',
}
